export default __webpack_public_path__ + "static/media/learnGatsby.f22d6679.md";